import CookieConsent from './consent'
import Cookie from './cookie'


CookieConsent.cookie = Cookie

export default CookieConsent
